var DogRecipeInfo = {
    beef: {
        descriptionLong: "Pups go crazy for the savory chunks of premium, protein-rich beef.\n    Bursting with vibrant flavors and featuring our proprietary nutrient blend,\n    this vet-developed recipe supports your dog\u2019s well-being and functional\n    health.",
        displayName: 'Beef Mash',
        ingredients: "Ground Beef, Russet Potatoes, Eggs, Carrots, Peas, Water\n    Sufficient for Processing, Dicalcium Phosphate, Potassium Chloride, Salt,\n    Citric Acid, Natural Flavor, Vinegar, Calcium Carbonate, Taurine, Fish Oil,\n    Sunflower Oil, Dimagnesium Phosphate, Zinc Gluconate, Iron Amino Acid\n    Chelate, Vitamin E Supplement, Potassium Iodide, Vitamin B12 Supplement,\n    Copper Gluconate, Manganese Gluconate, Selenium Amino Acid Chelate, Niacin\n    (Vitamin B3), Thiamine Mononitrate (Vitamin B1), Pyridoxine Hydrochloride\n    (Vitamin B6), Riboflavin (Vitamin B2), Folic Acid, Vitamin A Supplement,\n    Cholecalciferol (Source of Vitamin D3), Pantothenic Acid\n    (Calcium-D-Pantothenate)",
        isNew: false,
        nutritionInfo: {
            caloriesPerUnit: 201,
            caloriesPerKilogram: 1194,
            carbohydrateCalories: 42,
            carbohydrateGrams: 13.4,
            carbohydratePercent: 8,
            fatCalories: 97,
            fatGrams: 8.4,
            fatPercent: 5,
            fiberGrams: 6.7,
            fiberPercent: 4,
            gramsPerUnit: 168,
            moistureGrams: 129.4,
            moisturePercent: 77,
            proteinCalories: 62,
            proteinGrams: 13.4,
            proteinPercent: 8,
        },
        priceIndicator: '$$$$',
        priceSpiderSku: 'DB24',
        v9SingleBundleSubtotal: 55.02,
    },
    chicken: {
        descriptionLong: "Even picky pups find it hard to resist our juicy chunks of premium\n    chicken.  Made with lean meat, vibrant veggies and our proprietary nutrient\n    blend, it\u2019s a meal designed to keep them happy, healthy and doing the\n    excited-for-dinner dance.",
        displayName: 'Chicken Cuisine',
        ingredients: "Diced Chicken, Sweet Potatoes, Water Sufficient for\n    Processing, Squash, Spinach, Natural Flavor, Sunflower Oil, Canola Oil,\n    Dicalcium Phosphate, Vinegar, Citric Acid, Salt, Calcium Carbonate, Fish\n    Oil, Taurine, Choline Bitartrate, Dimagnesium Phosphate, Zinc Gluconate,\n    Iron Amino Acid Chelate, Vitamin E Supplement, Potassium Iodide, Vitamin B12\n    Supplement, Copper Gluconate, Manganese Gluconate, Selenium Amino Acid\n    Chelate, Niacin (Vitamin B3), Thiamine Mononitrate (Vitamin B1), Pyridoxine\n    Hydrochloride (Vitamin B6), Riboflavin (Vitamin B2), Folic Acid, Vitamin A\n    Supplement, Cholecalciferol (Source of Vitamin D3), Pantothenic Acid\n    (Calcium-D-Pantothenate)",
        isNew: false,
        nutritionInfo: {
            caloriesPerUnit: 248,
            caloriesPerKilogram: 1111,
            carbohydrateCalories: 40,
            carbohydrateGrams: 17.8,
            carbohydratePercent: 8,
            fatCalories: 121,
            fatGrams: 8.9,
            fatPercent: 4,
            fiberGrams: 8.9,
            fiberPercent: 4,
            gramsPerUnit: 233,
            moistureGrams: 169.5,
            moisturePercent: 76,
            proteinCalories: 87,
            proteinGrams: 17.8,
            proteinPercent: 8,
        },
        priceIndicator: '$$',
        priceSpiderSku: 'DC24',
        v9SingleBundleSubtotal: 45.99,
    },
    lamb: {
        descriptionLong: "Lamb Pilaf presents a tasty protein alternative to chicken and beef,\n    and is great for pup parents looking to serve a grain-inclusive diet. It\n    features our proprietary nutrient blend, and bursts with floor-licking\n    delicious textures and tastes. We like to think of it as dog food for dog\n    foodies.",
        displayName: 'Lamb Pilaf',
        ingredients: "Ground Lamb, Brown Rice, Egg, Carrots, Peas, Water\n    Sufficient for Processing, Dicalcium Phosphate, Natural Flavor, Citric Acid,\n    Vinegar, Salt, Calcium Carbonate, Potassium Chloride, Choline Bitartrate,\n    Potassium Carbonate, Dimagnesium Phosphate, Zinc Gluconate, Iron Amino Acid\n    Chelate, Canola Oil, Vitamin E Supplement, Potassium Iodide, Vitamin B12\n    Supplement, Copper Gluconate, Manganese Gluconate, Selenium Amino Acid\n    Chelate, Niacin (Vitamin B3), Thiamine Mononitrate (Vitamin B1), Pyridoxine\n    Hydrochloride (Vitamin B6), Riboflavin (Vitamin B2), Folic Acid, Vitamin A\n    Supplement, Cholecalciferol (Source of Vitamin D3), Calcium Pantothenate\n    (Vitamin B5).",
        isNew: true,
        nutritionInfo: {
            caloriesPerUnit: 236,
            caloriesPerKilogram: 1183,
            carbohydrateCalories: 71,
            carbohydrateGrams: 26,
            carbohydratePercent: 13,
            fatCalories: 108,
            fatGrams: 9,
            fatPercent: 4.5,
            fiberGrams: 8,
            fiberPercent: 4,
            gramsPerUnit: 200,
            moistureGrams: 150,
            moisturePercent: 75,
            proteinCalories: 57,
            proteinGrams: 12,
            proteinPercent: 6,
        },
        priceIndicator: '$$$$',
        priceSpiderSku: '40517',
        v9SingleBundleSubtotal: 61.88,
    },
    pork: {
        descriptionLong: "Pork Potluck is great for dog parents looking for an alternative to\n    chicken or beef. This vet-developed, floor-licking delicious recipe also\n    features our proprietary nutrient blend. Bursting with enriching aromas,\n    textures and tastes, it\u2019s a meal you can confidently serve \u2014 and your pup will\n    excitedly eat.",
        displayName: 'Pork Potluck',
        ingredients: "Ground Pork, Russet Potatoes, Squash, Green Beans, Kale,\n    Cremini Mushrooms, Potassium Chloride, Dicalcium Phosphate, Salt, Natural\n    Flavor, Vinegar, Citric Acid, Calcium Carbonate, Fish Oil, Taurine, Choline\n    Bitartrate, Dimagnesium Phosphate, Zinc Gluconate, Iron Amino Acid Chelate,\n    Vitamin E Supplement, Potassium Iodide, Vitamin B12 Supplement, Copper\n    Gluconate, Manganese Gluconate, Selenium Amino Acid Chelate, Niacin (Vitamin\n    B3), Thiamine Mononitrate (Vitamin B1), Pyridoxine Hydrochloride (Vitamin\n    B6), Riboflavin (Vitamin B2), Folic Acid, Vitamin A Supplement,\n    Cholecalciferol (Source of Vitamin D3), Pantothenic Acid\n    (Calcium-D-Pantothenate).",
        isNew: false,
        nutritionInfo: {
            caloriesPerUnit: 246,
            caloriesPerKilogram: 1217,
            carbohydrateCalories: 40,
            carbohydrateGrams: 19.5,
            carbohydratePercent: 10,
            fatCalories: 132,
            fatGrams: 9.8,
            fatPercent: 5,
            fiberGrams: 7.8,
            fiberPercent: 4,
            gramsPerUnit: 195,
            moistureGrams: 143.6,
            moisturePercent: 75,
            proteinCalories: 74,
            proteinGrams: 15.6,
            proteinPercent: 8,
        },
        priceIndicator: '$$$',
        priceSpiderSku: 'DP24',
        v9SingleBundleSubtotal: 49,
    },
    turkey: {
        descriptionLong: "This vet-developed recipe is made with premium, highly digestible\n    turkey that helps support pups with sensitive tummies.  Featuring a\n    proprietary nutrient blend for your dog\u2019s unique health needs,\n    and a mix of tempting textures and tastes to stimulate their senses,\n    it\u2019s a floor-licking delicious addition to a grain-inclusive diet.",
        displayName: 'Turkey Fare',
        ingredients: "Ground Turkey, Brown Rice, Egg, Carrots, Spinach, Water\n    Sufficient for Processing, Dicalcium Phosphate, Citric Acid, Salt, Vinegar,\n    Calcium Carbonate, Potassium Chloride, Vitamin E Supplement, Natural\n    Flavors, Fish Oil, Taurine, Dimagnesium Phosphate, Zinc Gluconate, Iron\n    Amino Acid Chelate, Potassium Iodide, Vitamin B12 Supplement, Copper\n    Gluconate, Manganese Gluconate, Selenium Amino Acid Chelate, Niacin (Vitamin\n    B3), Thiamine Mononitrate (Vitamin B1), Pyridoxine Hydrochloride (Vitamin\n    B6), Riboflavin (Vitamin B2), Folic Acid, Vitamin A Supplement,\n    Cholecalciferol (Source of Vitamin D3), Pantothenic Acid\n    (Calcium-D-Pantothenate).",
        isNew: false,
        nutritionInfo: {
            caloriesPerUnit: 244,
            caloriesPerKilogram: 1296,
            carbohydrateCalories: 59,
            carbohydrateGrams: 20.7,
            carbohydratePercent: 11,
            fatCalories: 108,
            fatGrams: 7.5,
            fatPercent: 4,
            fiberGrams: 7.5,
            fiberPercent: 4,
            gramsPerUnit: 188,
            moistureGrams: 135.4,
            moisturePercent: 72,
            proteinCalories: 77,
            proteinGrams: 16.9,
            proteinPercent: 9,
        },
        priceIndicator: '$$$',
        priceSpiderSku: 'DT24',
        v9SingleBundleSubtotal: 49,
    },
    turkey_chicken: {
        descriptionLong: "Featuring a duo of lean proteins, this recipe is a\n    do-that-dance delicious choice for dogs craving variety. It also contains our\n    proprietary nutrient blend for complete and balanced nutrition, making it a\n    win-win dinner for pups \u2014 and the parents that dote on them",
        displayName: 'Turkey & Chicken Cookout',
        ingredients: "Sweet Potato, Ground Turkey, Diced Chicken, Kale, Peas, Egg,\n    Canola Oil, Dicalcium Phosphate, Vinegar, Fish Oil, Sunflower Oil, Water\n    Sufficient for Processing, Citric Acid, Salt, Natural Flavors, Calcium\n    Carbonate, Taurine, Choline Bitartrate, Dimagnesium Phosphate, Zinc\n    Gluconate, Iron Amino Acid Chelate, Vitamin E Supplement, Potassium Iodide,\n    Vitamin B12 Supplement, Copper Gluconate, Manganese Gluconate, Selenium\n    Amino Acid Chelate, Niacin (Vitamin B3), Thiamine Mononitrate (Vitamin B1),\n    Pyridoxine Hydrochloride (Vitamin B6), Riboflavin (Vitamin B2), Folic Acid,\n    Vitamin A Supplement, Cholecalciferol (Source of Vitamin D3), Calcium\n    Pantothenate (Vitamin B5).",
        isNew: true,
        nutritionInfo: {
            gramsPerUnit: 210,
            caloriesPerUnit: 254,
            caloriesPerKilogram: 1213,
            proteinCalories: 63,
            proteinPercent: 7,
            proteinGrams: 14.7,
            fatCalories: 133,
            fatPercent: 5,
            fatGrams: 10.5,
            carbohydrateCalories: 58,
            carbohydratePercent: 11,
            carbohydrateGrams: 23.1,
            fiberPercent: 5,
            fiberGrams: 10.5,
            moisturePercent: 76,
            moistureGrams: 159.6,
        },
        priceIndicator: '$$$',
        priceSpiderSku: '40717',
        v9SingleBundleSubtotal: 47.53,
    },
};
export { DogRecipeInfo };
